import { render, staticRenderFns } from "./Atende.vue?vue&type=template&id=19d09027&"
import script from "./Atende.vue?vue&type=script&lang=js&"
export * from "./Atende.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports